// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"4a254561","626":"1a83ff3b","667":"8b534c78"}[chunkId] + ".chunk.js";
};